'use client'

// src/usePrevious.ts
import { useEffect, useRef } from "react";
var usePrevious = (value) => {
  const previousValueRef = useRef(null);
  useEffect(() => {
    previousValueRef.current = value;
  }, [value]);
  return previousValueRef.current;
};

export {
  usePrevious
};
//# sourceMappingURL=chunk-E6NERPVS.mjs.map